<!-- <moduurnv2-organization-locations-desktop>
</moduurnv2-organization-locations-desktop> -->

<!-- <moduurnv2-organization-locations> </moduurnv2-organization-locations> -->
<!-- <ng-container *ngIf="isMobileView; then mobile; else desktop"></ng-container>

<ng-template #mobile>
  <moduurnv2-organization-locations> </moduurnv2-organization-locations>
</ng-template>

<ng-template #desktop>
  <moduurnv2-organization-locations-desktop></moduurnv2-organization-locations-desktop>
</ng-template> -->

<moduurnv2-organization-locations> </moduurnv2-organization-locations>
